const SCOPE_TYPES = {
  COMPONENT: 'COMPONENT_SCOPE',
  GLOBAL: 'GLOBAL_SCOPE',
}

module.exports.SCOPE_TYPES = SCOPE_TYPES
